const SECTION_DIAGNOSIS_LABELS = Object.freeze({
  SECTION_DIAGNOSIS_OK: 'OK',
  SECTION_DIAGNOSIS_IDENTITY_DRIFT: 'Identidade divergente',
  SECTION_DIAGNOSIS_CROSS_SECTION_CONTAMINATION: 'Contaminação',
  SECTION_DIAGNOSIS_PIPELINE_AUTHORITY_INVALID: 'Autoridade da seção inválida',
  SECTION_DIAGNOSIS_INELIGIBLE_OR_EXCLUDED: 'Seção fora da aprovação',
  SECTION_DIAGNOSIS_CORE_BLOCKED_DATA: 'Dados autoritativos insuficientes',
  SECTION_DIAGNOSIS_CORE_BLOCKED_HARD: 'Bloqueio técnico',
  SECTION_DIAGNOSIS_PROVIDER_ENRICHMENT_REJECTED: 'Enriquecimento editorial rejeitado',
  SECTION_DIAGNOSIS_STRUCTURAL_CAPABILITY: 'Capacidade estrutural',
  SECTION_DIAGNOSIS_OBSERVED_MENTIONABLE_ELEMENT_CONTAMINATION: 'Elemento de outra seção',
  SECTION_DIAGNOSIS_GENERIC_SPEECH: 'Fala genérica',
  SECTION_DIAGNOSIS_EVIDENCE_MISSING: 'Capacidade estrutural',
  SECTION_DIAGNOSIS_RECOVERABLE_REJECTION: 'Rejeição recuperável',
  SECTION_DIAGNOSIS_CLIENT_REJECTED: 'Rejeitado pelo cliente',
  SECTION_DIAGNOSIS_NEEDS_LOCAL_FIX: 'Correção local',
});

const SECTION_DIAGNOSIS_ACTION_LABELS = Object.freeze({
  REVISAR_IDENTIDADE_DA_SECAO_E_REGENERAR_LOCAL: 'Revisar identidade e regenerar localmente',
  REGENERAR_FALA_LOCAL_COM_CONTRAEXEMPLOS_PRIVADOS: 'Regenerar com contraexemplos privados',
  REVALIDAR_AUTORIDADE_DA_SECAO: 'Revalidar autoridade da seção',
  MANTER_TEXTO_OCULTO_E_CORRIGIR_BLOQUEIO_DURO: 'Corrigir bloqueio técnico antes de exibir texto',
  CORRIGIR_DADOS_AUTORITATIVOS_ANTES_DE_GERAR: 'Corrigir dados autoritativos antes de gerar',
  MANTER_SECAO_FORA_DA_APROVACAO_ATE_REVALIDAR_AUTORIDADE: 'Manter fora da aprovação até revalidar',
  COMPLETAR_EVIDENCIA_DA_PLANTA_OU_IA_PLANTA: 'Adicionar contexto opcional',
  REVISAR_DECISAO_DO_CLIENTE_E_CORRIGIR_LOCALMENTE: 'Corrigir localmente',
  REGENERAR_COM_ORIENTACAO_MAIS_ESPECIFICA: 'Regenerar com orientação específica',
  EDITAR_RASCUNHO_E_REAUDITAR_LOCALMENTE: 'Corrigir enriquecimento editorial',
  CORRIGIR_SECAO_LOCALMENTE_SEM_BLOQUEAR_AS_DEMAIS: 'Corrigir só esta seção',
  REVISAR_RASCUNHO_ESTRUTURAL: 'Revisar rascunho estrutural',
  MANTER: 'Manter',
});

export function sectionDiagnosisLabel(code) {
  return SECTION_DIAGNOSIS_LABELS[code] || code || 'Sem diagnóstico';
}

export function sectionDiagnosisActionLabel(action) {
  return SECTION_DIAGNOSIS_ACTION_LABELS[action] || action || 'Sem ação';
}

export function countNoun(count, singular, plural) {
  const value = Number(count || 0);
  return `${value} ${value === 1 ? singular : plural}`;
}

export function physicalSectionHint(section) {
  const identity = String(section?.sectionId || section?.sectionKey || '').trim();
  const routeIndex = Number.isInteger(section?.routeIndex) ? section.routeIndex + 1 : null;
  const parts = [];
  if (routeIndex) parts.push(`parada ${routeIndex}`);
  if (identity) parts.push(`ID ${identity.replace(/^section-id:/, '')}`);
  return parts.join(' · ');
}
